import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/leave-records',
    name: 'leave-record',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/leave-record/index.vue')
  },
  {
    path: '/leave-records/create',
    name: 'leave-record-create',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/leave-record/create.vue')
  },
  {
    path: '/leave-records/:id',
    name: 'leave-record-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/leave-record/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('hr/leaveRecord/find', to.params.id)
      next()
    }
  }
]
